<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <DxToolbar class='select-group'>
        <DxItem
          #default
          location="before"
          locate-in-menu="never"
        >
          <div class="toolbar-label"><b>년도 : </b></div>
        </DxItem>
        <DxItem
          :options="selectBoxYearOptions"
          location="before"
          locate-in-menu="auto"
          widget="dxSelectBox"
        />
        <DxItem
          #default
          location="before"
          locate-in-menu="never"
        >
          <div class="toolbar-label"><b>월 : </b></div>
        </DxItem>
        <DxItem
          :options="selectBoxMonthOptions"
          location="before"
          locate-in-menu="auto"
          widget="dxSelectBox"
        />
        <DxItem
          #default
          location="before"
          locate-in-menu="never"
        >
          <div class="toolbar-label"><b>거래처 : </b></div>
        </DxItem>
        <DxItem
          :options="selectBoxVendorOptions"
          location="before"
          locate-in-menu="auto"
          widget="dxSelectBox"
        />
        <!-- <DxItem
          #default
          location="after"
          locate-in-menu="never"
        >
          <div class="toolbar-label"><b>단위(천원)</b></div>
        </DxItem> -->
      </DxToolbar>
      <DxPivotGrid
        ref="refPivot"
        :allow-sorting-by-summary="true"
        :allow-sorting="true"
        :allow-filtering="true"
        :allow-expand-all="true"
        :show-borders="true"
        :show-column-grand-totals="false"
        :show-row-grand-totals="true"
        :show-row-totals="false"
        :show-column-totals="true"
        :data-source="dataSource"
        @cell-prepared = 'onCellPrepared'
        @cell-click = 'onCellClick'
        @exporting="onExporting"
      >
        <DxFieldChooser
          :enabled="false"
          :height="400"
        />
        <DxExport
          :enabled="true"
          :file-name="excelTitle"
        />
      </DxPivotGrid>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import { DxPivotGrid, DxFieldChooser, DxExport } from 'devextreme-vue/pivot-grid'
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
import AppLib from '../../share/AppLib'
// excel export 관련 lib
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportPivotGrid } from 'devextreme/excel_exporter'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '원자재 사급내역'
        }
      ],
      thisYear: null,
      selectBoxYearOptions: null,
      selectBoxMonthOptions: null,
      selectBoxVendorOptions: null,
      selectedMonth: null,
      selectedVendor: 'ALL',
      dailyStatus: null,
      dataSource: null,
      excelTitle: null,
      총합계금액: null,
      거래처리스트: []
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxToolbar,
    DxPivotGrid,
    DxItem,
    DxFieldChooser,
    DxExport
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.init()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    init () {
      this.thisYear = AppLib.getThisYear()
      this.selectedMonth = AppLib.getThisMonth()

      let tempArray = []
      for (let i = this.thisYear; i >= 2020; i--) {
        tempArray.push({ 'year': i })
      }
      this.selectBoxYearOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'year',
        displayExpr: 'year',
        value: this.thisYear,
        onValueChanged: (args) => {
          this.thisYear = args.value
          this.refreshDataGrid(this.thisYear, this.selectedMonth, true)
        }
      }
      tempArray = []
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          tempArray.push({ 'name': i + '월', value: '0' + i })
        } else {
          tempArray.push({ 'name': i + '월', value: '' + i })
        }
      }
      this.selectBoxMonthOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'value',
        displayExpr: 'name',
        value: this.selectedMonth,
        onValueChanged: (args) => {
          this.selectedMonth = args.value
          this.refreshDataGrid(this.thisYear, this.selectedMonth, true)
        }
      }
      this.refreshDataGrid(this.thisYear, this.selectedMonth, true)
    },
    /* ==============START EXCEL EXPORT============ */
    onExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet(this.excelTitle)
      exportPivotGrid({
        component: e.component,
        worksheet,
        customizeCell: ({ pivotCell, excelCell }) => {
          if (excelCell._column._number === 5) {
            if (excelCell._value.model.value !== null) {
              Object.assign(excelCell, { font: { color: { argb: '0000FF' }, bold: false } })
            }
          }
          if (excelCell._value.model.value === '총합계') {
            excelCell._value.model.value = `총 합계금액             :         ${this.총합계금액}`
            Object.assign(excelCell, { font: { color: { argb: '0000FF' }, bold: false } })
          }
          if (excelCell._value.model.value === 0) {
            excelCell._value.model.value = ''
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.excelTitle}.xlsx`)
        })
      })
      e.cancel = true
    },
    /* ==============END EXCEL EXPORT============ */
    onCellClick (e) {
      if (e.area === 'column' && e.rowIndex === 0 && e.columnIndex === 0) { e.cancel = true }
      if (e.area === 'row' && e.cell.text.indexOf('7.') < 0) { e.cancel = true }
    },
    onCellPrepared (e) {
      if (e.cell.type === 'GT') {
        this.$Q(e.cellElement).find('span').html(`총 합계금액 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ${this.총합계금액}(원)`)
        this.$Q(e.cellElement).find('span').css('color', 'blue')
      }
      if (e.area === 'data') {
        if (e.cell.value === 0) {
          this.$Q(e.cellElement).find('span').text('')
        }
      }
      if (e.area === 'row') {
        if (e.cell.text.includes('금액')) this.$Q(e.cellElement).find('span').css('color', 'blue')
      }
    },
    makeDaily (dailyStatus) {
      let totalPrice = 0
      if (dailyStatus.length === 0) {
        this.setInitDataSource()
        return
      }
      console.log(dailyStatus)
      const mDay = AppLib.getMonthLastDay(this.thisYear, this.selectedMonth)
      const gByPcode = this.$_.groupBy(dailyStatus, function (list) { return list.품번 })
      for (const [key, value] of Object.entries(gByPcode)) {
        console.log(`${key} : ${value[0].제품금액}`)
        totalPrice += value[0].제품금액
      }
      this.총합계금액 = AppLib.comma(totalPrice)
      let timeStamp
      for (let i = 1; i <= mDay; i++) {
        timeStamp = AppLib.getTimestampFromformat(this.thisYear, this.selectedMonth, i)
        let where = this.$_.findWhere(dailyStatus, { 발생일: timeStamp, 품번: dailyStatus[0].품번 })
        if (where === undefined) {
          const temp = {
            거래처명: dailyStatus[0].거래처명,
            차종: dailyStatus[0].차종,
            규격: dailyStatus[0].규격,
            발생일: timeStamp,
            품명: dailyStatus[0].품명,
            품번: dailyStatus[0].품번,
            그룹수량: 0,
            금액: dailyStatus[0].금액
          }
          dailyStatus.push(temp)
        }
      }
      this.setInitDataSource()
    },
    makeVendorSelectedOption () {
      this.거래처리스트.unshift({ 거래처명: 'ALL', 거래처코드: 'ALL' })
      this.selectBoxVendorOptions = {
        width: 100,
        items: this.거래처리스트,
        valueExpr: '거래처코드',
        displayExpr: '거래처명',
        value: this.selectedVendor,
        onValueChanged: (args) => {
          this.selectedVendor = args.value
          this.refreshDataGrid(this.thisYear, this.selectedMonth, false)
        }
      }
    },
    refreshDataGrid (year, month, isRefreshVendorList) {
      this.isLoading = true
      const param = {
        startDate: `${year}-${month}-01`,
        endDate: `${year}-${month}-${AppLib.getMonthLastDay(year, month)} 23:59:59`,
        입출고구분: ConstDef.사급출고,
        거래처코드: this.selectedVendor
      }
      this.$_sp.runNoEncodeFindProc('spFindAllRawMaterialsOutputByDate', param)
        .then((data) => {
          this.isLoading = false
          this.dailyStatus = this.$_sp.MakeModel(data)
          console.log(this.dailyStatus)
          // this.searchEmptyPressSize(this.dailyStatus)
          this.makeDaily(this.dailyStatus)
          if (isRefreshVendorList) {
            const gByVendorList = this.$_.groupBy(this.dailyStatus, function (vendorList) { return [vendorList.거래처명, vendorList.거래처코드] })
            let array = Object.keys(gByVendorList)
            this.거래처리스트 = []
            for (let i in array) {
              this.거래처리스트.push({ 거래처명: array[i].split(',')[0], 거래처코드: array[i].split(',')[1] })
            }
            this.makeVendorSelectedOption()
          }
          this.excelTitle = `${year}-${month} 사급내역`
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    setInitDataSource () {
      this.dataSource = new PivotGridDataSource({
        fields: [
          {
            caption: '',
            dataField: '거래처명',
            area: 'row',
            width: '40',
            expanded: true
          },
          {
            caption: '',
            dataField: '차종',
            area: 'row',
            width: '40',
            expanded: true
          },
          {
            caption: '',
            dataField: '품번',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            caption: '',
            dataField: '규격',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            caption: '',
            dataField: '금액',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            dataField: '발생일',
            dataType: 'date',
            area: 'column',
            groupInterval: 'month',
            expanded: true
          },
          {
            dataField: '발생일',
            dataType: 'date',
            area: 'column',
            groupInterval: 'day'
          },
          {
            caption: '수량',
            dataField: '그룹수량',
            dataType: 'number',
            summaryType: 'sum',
            format: '#,##0',
            area: 'data'
          }

        ],
        store: this.dailyStatus
      })
    }
  }
}
</script>

<style lang="scss">

</style>
